var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.logined && _vm.bus.code !== 83001003 && _vm.bus.username)?_c('div',[_c('simple-menu',{attrs:{"menu-list":_vm.menuList}}),_vm._v(" "),_c('div',{staticClass:"small-app-content"},[_c('router-view',{attrs:{"app-info":_vm.appInfo}})],1)],1):_c('access-deny')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73df31ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/manage/Main.vue
// module id = null
// module chunks = 